import React from 'react';

interface ButtonProps {
  children: any;
  classes?: string;
  onClickHandler?: any;
  tooltip?: string;
  type?: keyof typeof ButtonType;
  disabled?: boolean;
  id?: string;
}

export enum ButtonType {
  button = 'button',
  submit = 'submit',
  reset = 'reset',
}

const Button = ({
  children,
  classes,
  onClickHandler,
  tooltip,
  type = ButtonType.button,
  disabled = false,
}: ButtonProps) => {
  return (
    <button
      title={tooltip}
      type={type ?? undefined}
      className={`${classes} button`}
      onClick={onClickHandler ?? undefined}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
